import EN_TRANSLATIONS from '@dadohr/shared/locales/en/translation.json';
import FR_TRANSLATIONS from '@dadohr/shared/locales/fr/translation.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * Translations are imported at build time from `@dadohr/shared`, which is the
 * single source of truth for every locale key across apps and backend. See
 * `new-main/packages/shared/src/deprecated/locales/` for the canonical files.
 *
 * Cache-busting rides on the JS bundle hash — no separate hash-locales step.
 */
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: EN_TRANSLATIONS },
      fr: { translation: FR_TRANSLATIONS }
    },
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    whitelist: ['en', 'fr']
  });

export default i18n;
